import formatDate from '../../helpers/dateFormat';

export const filterArchivedData = (obj: any) => {
  // filter for Archived is false
  const archiveData = obj.subscriptionReports;
  const filteredData = archiveData.filter((val: any) => {
    return val.archive === '1';
  });
  const filterColumnNames = ['prop_num', 'property_name', 'user_name', 'pin', 'last_updated', 'online_expires', 'update_type', 'sub_account']
  return FilterDataByParams(filterColumnNames, filteredData)
}

export const filterAllUsersData = (obj: any) => {
  if (typeof (obj) !== "undefined" || obj !== undefined) {
    const allUserData = obj.subscriptionReports;
    const filteredData = allUserData.filter((val: any) => {
      return val.archive === '0';
    });
    const filterColumnNames = ['prop_num', 'property_name', 'user_name', 'pin', 'last_updated', 'online_expires', 'update_type', 'sub_account']
    return FilterDataByParams(filterColumnNames, filteredData)
  }
}

export const filterAllUserNoRRData = (obj: any) => {
  const allUserNoRRData = obj.subscriptionReports;
  const filteredData = allUserNoRRData.filter((val: any) => {
    return val.archive === '0' && val.reseller !== 'RR';
  });
  const filterColumnNames = ['prop_num', 'user_name', 'pin', 'property_name', 'last_updated', 'online_expires', 'total_fee', 'template', 'state']
  return FilterDataByParams(filterColumnNames, filteredData)
}

export const filterAllSubscriptionsData = (obj: any) => {
  const allSubscriptionsData = obj.subscriptionReports;
  const filteredData = allSubscriptionsData.filter((val: any) => {
    return (val.web_news_fee > 0 || val.online_fee > 0 || val.warranty_fee > 0 || val.other_fee > 0) && (val.archive === '0' && !val.reseller);
  });
  const filterColumnNames = ['prop_num', 'property_name', 'last_updated', 'online_expires', 'total_fee', 'online_fee', 'warranty_fee', 'web_news_fee', 'other_fee', 'other_fee_desc', 'dsi_notes', 'template']
  return FilterDataByParams(filterColumnNames, filteredData)
}

export const filterSubscriptionsByDateData = (obj: any) => {
  const subscriptionsByDateData = obj.subscriptionReports;
  const filteredData = subscriptionsByDateData.filter((val: any) => {
    return val.archive === '1' && val.reseller !== 'RR';
  });
  const filterColumnNames = ['prop_num', 'property_name', 'last_updated', 'online_expires', 'total_fee', 'online_fee', 'warranty_fee', 'web_news_fee', 'other_fee', 'other_fee_desc', 'dsi_notes', 'template', 'user_name', 'pin']
  return FilterDataByParams(filterColumnNames, filteredData)
}

export const filterSubscriptionsByDate = (obj: any, date: any) => {
  const subscriptionsByDate = obj.SubscriptionsFilteredByDate;
  const filteredData = subscriptionsByDate.filter((val: any) => {
    return new Date(val.online_expires) < new Date(date);
  });
  const filterColumnNames = ['prop_num', 'property_name', 'last_updated', 'online_expires', 'total_fee', 'online_fee', 'warranty_fee', 'web_news_fee', 'other_fee', 'other_fee_desc', 'dsi_notes', 'template', 'user_name', 'pin']
  return date !== "" ? FilterDataByParams(filterColumnNames, filteredData) : subscriptionsByDate
}

export const filterExpiredUsersData = (obj: any) => {
  const expiredUsersData = obj.subscriptionReports;
  const filteredData = expiredUsersData.filter((val: any) => {
    return new Date(val.online_expires) < new Date(Date.now()) && val.archive === '1' && val.reseller !== 'RR';
  });
  const filterColumnNames = ['prop_num', 'property_name', 'last_updated', 'online_expires', 'total_fee', 'online_fee', 'warranty_fee', 'web_news_fee', 'other_fee', 'other_fee_desc', 'state', 'dsi_notes', 'updating_content', 'updating_email', 'billing_email', 'user_name', 'pin']
  return FilterDataByParams(filterColumnNames, filteredData)
}

export const filterExpiredUserDataByFilter = (obj: any, filterObj:any) => {
  const filteredData = obj.ExpiredUsers.filter((val: any) => {
    let returnValueFilter = true;
    let returnValueMonth = true;
    let returnValueYear = true;
    if (filterObj.FilterType !== 'all') {
      if (filterObj.FilterType === 'no_fees'){
        returnValueFilter = parseInt(val.total_fee, 10) === 0;
      } else if (filterObj.FilterType === 'all_fees'){
        returnValueFilter = parseInt(val.total_fee, 10) > 0;
      }
    } else {
      returnValueFilter = true
    }

    if (filterObj.SelectedMonth !== "all") {
      const expiredMonth = new Date(val.online_expires).getMonth();
      returnValueMonth = filterObj.SelectedMonth === expiredMonth.toString();
    }

    if (filterObj.SelectedYear !== "all") {
      const expiredYear = new Date(val.online_expires).getFullYear();
      returnValueYear = filterObj.SelectedYear === expiredYear.toString();
    }
    const returnValue = returnValueMonth && returnValueYear && returnValueFilter
  return returnValue;
  });
return filteredData;
}

export const filterExpire30DaysData = (obj: any) => {
  const expire30DaysData = obj.subscriptionReports;
  const filteredData = expire30DaysData.filter((val: any) => {
    const date = new Date();
    date.setDate(date.getDate() + 30);
    const thirtyDaysFromnow = date.setHours(0,0,0,0);
    return (
      new Date(val.online_expires).setHours(0, 0, 0, 0) >=
        new Date().setHours(0, 0, 0, 0) &&
      new Date(val.online_expires).setHours(0, 0, 0, 0) <=
        thirtyDaysFromnow &&
      val.archive === "0"
    );
  });
  const filterColumnNames = ['prop_num', 'property_name', 'last_updated', 'online_expires', 'total_fee', 'online_fee', 'warranty_fee', 'web_news_fee', 'other_fee', 'other_fee_desc', 'state', 'dsi_notes', 'template', 'user_name', 'pin']
  return FilterDataByParams(filterColumnNames, filteredData)
}

export const filterExpire120DaysData = (obj: any) => {
  const expire120DaysData = obj.subscriptionReports;
  const filteredData = expire120DaysData.filter((val: any) => {
     const date = new Date();
     date.setDate(date.getDate() + 120);
    const oneTwentyDaysFromnow = date.setHours(0, 0, 0, 0);
    return (
      new Date(val.online_expires).setHours(0, 0, 0, 0) >=
        new Date().setHours(0, 0, 0, 0) &&
      new Date(val.online_expires).setHours(0, 0, 0, 0) <=
        oneTwentyDaysFromnow &&
      val.archive === "0"
    );
  });
  const filterColumnNames = ['prop_num', 'property_name', 'last_updated', 'online_expires', 'total_fee', 'online_fee', 'warranty_fee', 'web_news_fee', 'other_fee', 'other_fee_desc', 'dsi_notes', 'template', 'updating_content', 'user_name', 'pin']
  return FilterDataByParams(filterColumnNames, filteredData)
}

export const filterAllTSLiveReportData = (obj: any) => {
  const allTSLiveReportData = obj.subscriptionReports;
  const filteredData = allTSLiveReportData.filter((val: any) => {
    return val.archive === '0' && val.web_news_fee > 0;
  });
  const filterColumnNames = ['prop_num', 'property_name', 'web_news_fee', 'dsi_notes', 'template', 'online_expires', 'user_name', 'pin']
  return FilterDataByParams(filterColumnNames, filteredData)
}

export const filterSpecialBillingReportData = (obj: any) => {
  const specialBillingReportData = obj.subscriptionReports;
  const filteredData = specialBillingReportData.filter((val: any) => {
    return val.archive === '0' && val.reseller === 'Other' && (val.online_fee > 0 || val.web_news_fee > 0 || val.warranty_fee > 0 || val.other_fee > 0);
  });
  const filterColumnNames = [
    "prop_num",
    "user_name",
    "pin",
    "property_name",
    "last_updated",
    "online_expires",
    "total_fee",
    "online_fee",
    "warranty_fee",
    "web_news_fee",
    "other_fee",
    "other_fee_desc",
    "dsi_notes"
  ];
  return FilterDataByParams(filterColumnNames, filteredData)
}

export const filterIrvineAccountsData = (obj: any) => {
  const irvineAccountsData = obj.subscriptionReports;
  const filteredData = irvineAccountsData.filter((val: any) => {
    return val.archive === '0' && val.reseller === 'Irvine';
  });
  const filterColumnNames = ['prop_num', 'user_name', 'pin', 'property_name', 'last_updated', 'online_expires', 'dsi_notes', 'total_fee', 'template', 'state']
  return FilterDataByParams(filterColumnNames, filteredData)
}

export const filterRedyRefData = (obj: any) => {
  const redyRefData = obj.subscriptionReports;
  const filteredData = redyRefData.filter((val: any) => {
    return val.archive === '0' && val.reseller === 'RR';
  });
  const filterColumnNames = ['prop_num', 'user_name', 'pin', 'property_name', 'last_updated', 'online_expires', 'total_fee', 'update_type']
  return FilterDataByParams(filterColumnNames, filteredData)
}

export const filterCancelledUserReportData = (obj: any) => {
  const cancelledUserReportData = obj.subscriptionReports;
  const filteredData = cancelledUserReportData.filter((val: any) => {
    return val.cancel_date !== "";
  });
  const filterColumnNames = ['prop_num', 'property_name', 'cancel_notes', 'state', 'cancel_date', 'online_expires', 'archive', 'cancel_reason', 'user_name', 'pin']
  return FilterDataByParams(filterColumnNames, filteredData)
}

export const FilterDataByParams = (params: any, obj: any) => {
  const newArray: any = [];
  let i: any = 0;
  for (i = 0; i < obj.length; i++) {
    const sortedArr: any = {};
    const Listings = obj[i];
    for (const propertyName in Listings) {
      if (params.indexOf(propertyName) !== -1) {
        // loop through properties
        if (propertyName === "last_updated" || propertyName === "online_expires" || propertyName === "cancel_date") {
          if (Listings[propertyName]) {
            sortedArr[propertyName] = !Listings[propertyName] ? null : formatDate(Listings[propertyName]);
          }
          else {
            sortedArr[propertyName] = null;
          }
        } else if (propertyName === 'prop_num' || propertyName === 'total_fee' || propertyName === 'online_fee' || propertyName === 'warranty_fee' || propertyName === 'web_news_fee' || propertyName === 'other_fee') {
          if (Listings[propertyName]) {
            sortedArr[propertyName] = parseInt(Listings[propertyName], 10);
          }
          else {
            sortedArr[propertyName] = 0;
          }
        }
        else if (propertyName === 'property_name' || propertyName === 'dsi_notes' || propertyName === 'cancel_reason' || propertyName === 'cancel_notes') {
          if (Listings[propertyName]) {
            sortedArr[propertyName] = Listings[propertyName].trim().replace(/[\/\\]/g, '')
          } else {
            sortedArr[propertyName] = null
          }
        }
        else {
          sortedArr[propertyName] = Listings[propertyName];
        }
      }
    }
    newArray.push(sortedArr)
  }
  return newArray;
}


// WEBPACK FOOTER //
// ./src/store/subscriptionReports/subscriptionReportsFilters.ts